import {
  formatedDay,
  formatedMonth,
  formatedMoneyWithFree,
  locale,
} from '../alpine-functions';

import { readStoredCart } from '../misc/cart-storage';

export default () => ({
  cart: [],
  locale: locale(),
  showCart: false,

  updateCart(first = false) {
    this.$nextTick(() => {
      this.cart = readStoredCart();

      if (!first) {
        this.showCart = true;
        setTimeout(() => {
          this.showCart = false;
        }, 5000);
      }
    });
  },

  formatedMoney(czk, eur) {
    return formatedMoneyWithFree(czk, eur);
  },

  formatedDay(event) {
    return formatedDay(event.start).replace('.', '');
  },

  formatedMonth(event) {
    return formatedMonth(event.start);
  },

  init() {
    this.updateCart(true);
  },
});
